import { createStyles, Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import RemoveIcon from '@material-ui/icons/Delete';
import { Grid, Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    disabled: {
      color: 'black',
    },
  }),
);

interface Params {
  editable?: boolean;
  valueComponent: React.ReactElement;
  onEditClick: () => void;
  onDeleteClick?: () => void;
}

export const CommissionDetailItem: React.FC<Params> = (props) => {
  const { editable, valueComponent, onEditClick, onDeleteClick } = props;
  const classes = useStyles();

  const handleEdit = () => {
    onEditClick();
  };

  const handleDelete = () => {
    if (onDeleteClick !== undefined) onDeleteClick();
  };

  return (
    <>
      <Grid item xs={11} className={classes.left}>
        {valueComponent}
      </Grid>
      <Grid item xs={1} className={classes.right}>
        {editable && (
          <>
            <Tooltip title="Modifier">
              <EditIcon className={classes.icon} onClick={handleEdit} />
            </Tooltip>
            <Tooltip title="Supprimer">
              <RemoveIcon className={classes.icon} onClick={handleDelete} />
            </Tooltip>
          </>
        )}
      </Grid>
    </>
  );
};
